export default __webpack_public_path__ + "static/media/icons-01.0f4f6b29.svg";